import React, { createContext, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { Button, Card, CardBody, CardHeader, Col, Form, FormGroup, FormText, Input, Row } from 'reactstrap'

import CharCheckModal from '../../components/molecules/CharCheckModal'
import TagsInput from '../../components/TagsInput'
import { api } from '../../utils/index'
import { ToastContainer } from 'react-toastify'
import { notify } from '../../utils/notify'
import Email from '../../main/FormFields/Email'
import FileInput from '../../components/molecules/FileInput'
import { useFileUpload } from '../../hooks'

export const EmailContext = createContext()


const KeywordIdeasForm = () => {
	const WORLDWIDE = "Worldwide"
	const SECOND_PASS_TOP_OPTIONS = [100, 200, 1000, 5000]
	const [keywords, setKeywords] = useState([])
	const [locations, setLocations] = useState([])
	const [file, setFiles] = useState(null)
	const [location, setLocation] = useState('')
	const [secondPassEnabled, setSecondPassEnabled] = useState(false)
	const [secondPassTopN, setSecondPassTopN] = useState(SECOND_PASS_TOP_OPTIONS[0])
  const { upload, loading } = useFileUpload()
  const [emails, setEmails] = useState([]);

	
	// Modal check caratteri
	const [showCharCheck, setShowCharCheck] = useState(false)
	const [errCharList, setErrCharList] = useState([])
	const [acceptedCharCheck, setAcceptedCharCheck] = useState(false)

	const confirmEvaluation = (e) => {
		e.preventDefault()
		setShowCharCheck(false)
		setAcceptedCharCheck(true)
	}

	const handleSubmit = async (event) => {
    if (event)
			event.preventDefault()

    if (emails.length === 0 || (file == null && keywords.length === 0)) {
      notify('Mail, file o keyword mancanti', 'error')
      return
    }

    let formData = new FormData()
    formData.append('keywords', keywords)
    formData.append('location', location)
    formData.append('mail', emails)
    formData.append('file', file)
		formData.append('second_pass_enabled', secondPassEnabled)
		if (secondPassEnabled) formData.append('second_pass_top_n', secondPassTopN)
    if (acceptedCharCheck) formData.append('accepted', acceptedCharCheck)

    try {
      await upload('post', 'keyword-ideas/', formData, {
        onSuccess: (data) => {
					if (typeof data !== 'undefined') {
						if (data?.type === 'application/force-download') {
							let url = window.URL.createObjectURL(data)
							let a = document.createElement('a')
							a.href = url
							a.download = 'report.xlsx'
							a.click()
						}
						notify('Request sent.', 'success')
						setKeywords([])
						setEmails([])
						setFiles(null)
						setSecondPassEnabled(false)
						setSecondPassTopN(SECOND_PASS_TOP_OPTIONS[0])
					} else {
						notify(
						"Could not retrieve datas.",
						'error'
						)
						console.warn('Could not retrieve datas')
					}
				},
        onError: (errorMessage, err) => {
          if (err.response?.data?.message?.includes('ERROR Encoding keywords')) {
            setErrCharList(err.response.data?.errors)
            setShowCharCheck(true)
          } else {
            notify(errorMessage, 'error')
            setKeywords([])
            setEmails([])
            setFiles(null)
						setSecondPassEnabled(false)
						setSecondPassTopN(SECOND_PASS_TOP_OPTIONS[0])
          }
        },
      })
    } catch (err) {
      console.error('Keyword Ideas failed:', err)
    }
  }

	const selectedKeywords = keywords => {
		setKeywords(keywords)
	}

	useEffect(() => {
		api
		.get('motori-ricerca/')
		.then(res => {
			let locations = []
			try {
				for (let i = 0; i < res.data.length; i++) {
					locations.push(res.data[i].locale)
				}
			} catch {
				console.warn('Error while parsing locations')
			}
			locations.push(WORLDWIDE)
			locations = Array.from(new Set(locations))
			//setLocation('it-it')
			setLocations(locations)
		})
		.catch(err => console.error(err))
	}, [])

	useEffect(() => {
		if(acceptedCharCheck) {
			handleSubmit()
		}
	}, [acceptedCharCheck])

		return (
			<>
				<CharCheckModal show={showCharCheck} onHide={setShowCharCheck} onSubmit={confirmEvaluation} errCharList={errCharList}/>
				{loading ? (
					<Spinner animation="grow" />
				) : (
				<Row>
				<div className="col pb-5">
				<Card className="bg-secondary shadow">
					<CardHeader className="bg-white border-0">
						<Row style={{ marginLeft: "0px" }}>
							<Col md={10}>
								<h1 className="mb-0">Keyword Ideas</h1>
							</Col>
						</Row>
					</CardHeader>
					<CardBody>
						<Form onSubmit={handleSubmit} id="idea-form" action="">
							<Row>
								<Col md={6}>
									<FileInput
										onFileChange={setFiles}
										accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
										helpText={
											<>
												Carica un file contenente le tue keywords. <br />
												<b>Il file deve contenere almeno una colonna "Keyword"</b>
											</>
										}
										required={false}
									/>
									<FormGroup>
										<label htmlFor="location" style={{ display: 'block' }}>
											Location
										</label>
										<Input
											type="select"
											className="form-control-alternative"
											id="location"
											value={location}
											required
											style={{ height: '44px' }}
											onChange={event => {
												setLocation(event.target.value)
											}}
										>
											{locations.map(location => {
												return (
													<option key={location} value={location}>
														{location}
													</option>
												)
											})}
										</Input>
									</FormGroup>
									<FormGroup check className="pl-0 mt-2">
										<div className="d-flex align-items-center">
											<label htmlFor="second-pass-enabled" className="form-check-label mb-0">
												<Input
													id="second-pass-enabled"
													type="checkbox"
													checked={secondPassEnabled}
													onChange={event => setSecondPassEnabled(event.target.checked)}
												/>
												Seconda passata automatica
											</label>
										</div>
										<FormText color="muted" className="mt-1 pl-0">
											Esegue una seconda chiamata su un sottoinsieme delle keyword emerse dalla prima passata.
										</FormText>
									</FormGroup>
									{secondPassEnabled && (
										<FormGroup className="mt-2">
											<label htmlFor="second-pass-top-n" className="form-control-label">
												Top keyword per seconda passata
											</label>
											<Input
												type="select"
												id="second-pass-top-n"
												className="form-control-alternative"
												value={secondPassTopN}
												onChange={event => setSecondPassTopN(Number(event.target.value))}
											>
												{SECOND_PASS_TOP_OPTIONS.map(option => (
													<option key={option} value={option}>
														{option}
													</option>
												))}
											</Input>
										</FormGroup>
									)}
								</Col>
								<Col md={6}>
									<FormGroup required>
									<label htmlFor="keywords" className="form-control-label">
										Keywords
									</label>
									<TagsInput
										className="form-control-alternative"
										id='keywords'
										selectedTags={selectedKeywords}
										tags={keywords}
										type='text'
									/>
									<FormText color="muted" align={'left'}>
										Inserisci eventuali keywords aggiuntive. <br />
										<b>Premi invio dopo ogni nuovo inserimento.</b>
									</FormText>
									</FormGroup>
									<FormGroup>
										<EmailContext.Provider value={{ emails, setEmails }}>
                    	<Email context={EmailContext} />
                  	</EmailContext.Provider>
									</FormGroup>
								</Col>
							</Row>
							<Row style={{display: "flex", justifyContent: "flex-end", marginRight:"50px"}}>
							<Button color="info" size="lg" onClick={handleSubmit} >Submit Report</Button>
							</Row>
						</Form>
					</CardBody>
				</Card>
				</div>
				</Row>
				)}
				<ToastContainer />
			</>
		)
}

export default KeywordIdeasForm
